// import axios from 'axios';
// import { Capacitor } from '@capacitor/core';
// import { Http } from '@capacitor-community/http';

// const BASE_URL = import.meta.env.VITE_BASE_URL;

// async function capacitorAdapter(config) {
//   let base = config.baseURL;
//   let path = config.url;

//   if (base.endsWith('/')) {
//     base = base.slice(0, -1);
//   }

//   if (!path.startsWith('/')) {
//     path = '/' + path;
//   }

//   const fullUrl = base + path;

//   const response = await Http.request({
//     method: (config.method || 'get').toUpperCase(),
//     url: fullUrl,
//     headers: config.headers || {},
//     data: config.data,
//     params: config.params,
//   });

//   return {
//     data: response.data,
//     status: response.status,
//     statusText: response.statusText || '',
//     headers: response.headers,
//     config,
//     request: null,
//   };
// }

// const useNative = Capacitor.getPlatform && Capacitor.getPlatform() !== 'web';
// const adapter = useNative ? capacitorAdapter : axios.defaults.adapter;

// export const axiosInstance = axios.create({
//   baseURL: BASE_URL,
//   adapter,
// });

// axiosInstance.interceptors.request.use(
//   (cfg) => {
//     console.log('REQUEST config:', cfg);
//     return cfg;
//   },
//   (err) => {
//     console.error('REQUEST ERROR:', err);
//     return Promise.reject(err);
//   }
// );

// axiosInstance.interceptors.response.use(
//   (res) => {
//     console.log('RESPONSE data:', res.data);
//     return res;
//   },
//   (err) => {
//     console.error('RESPONSE ERROR:', err);
//     return Promise.reject(err);
//   }
// );

import axios from 'axios';
import { Capacitor } from '@capacitor/core';
import { Http } from '@capacitor-community/http';

const BASE_URL = import.meta.env.VITE_BASE_URL;

// Ensure query param values are strings (required by Capacitor HTTP on iOS)
function stringifyQueryParams(obj) {
  if (!obj || typeof obj !== 'object') return obj;
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v == null) continue; // skip null/undefined
    if (Array.isArray(v)) out[k] = v.map((x) => String(x));
    else out[k] = String(v);
  }
  return out;
}

async function capacitorAdapter(config) {
  let base = config.baseURL || '';
  let path = config.url || '';

  if (base.endsWith('/')) base = base.slice(0, -1);
  if (path && !path.startsWith('/')) path = '/' + path;

  const fullUrl = base + path;

  // Flatten accidental nesting: { params: { params: {...} } }
  let params =
    config.params && config.params.params
      ? config.params.params
      : config.params;

  const method = (config.method || 'get').toUpperCase();
  const platform = Capacitor.getPlatform?.();

  // iOS GET: Capacitor HTTP requires query values to be strings
  if (platform === 'ios' && method === 'GET' && params) {
    params = stringifyQueryParams(params);
  }

  const response = await Http.request({
    method,
    url: fullUrl,
    headers: config.headers || {},
    data: config.data, // bodies untouched
    params,
  });

  const axiosResponse = {
    data: response.data,
    status: response.status,
    statusText: response.statusText || '',
    headers: response.headers,
    config,
    request: null,
  };

  // Honor axios validateStatus — throw error for non-2xx so interceptors handle it correctly
  const validateStatus = config.validateStatus || ((s) => s >= 200 && s < 300);
  if (!validateStatus(response.status)) {
    const error = new Error(
      `Request failed with status code ${response.status}`
    );
    error.config = config;
    error.request = null;
    error.response = axiosResponse;
    error.isAxiosError = true;
    throw error;
  }

  return axiosResponse;

  // return {
  //   data: response.data,
  //   status: response.status,
  //   statusText: response.statusText || '',
  //   headers: response.headers,
  //   config,
  //   request: null,
  // };
}

const useNative = Capacitor.getPlatform && Capacitor.getPlatform() !== 'web';
const adapter = useNative ? capacitorAdapter : axios.defaults.adapter;

export const axiosInstance = axios.create({
  baseURL: BASE_URL,
  validateStatus: (status) => status >= 200 && status < 300,
  adapter,
});

axiosInstance.interceptors.request.use(
  (cfg) => {
    console.log('REQUEST config:', cfg);
    return cfg;
  },
  (err) => {
    console.error('REQUEST ERROR:', err);
    return Promise.reject(err);
  }
);

axiosInstance.interceptors.response.use(
  (res) => {
    console.log('RESPONSE data:', res.data);
    return res;
  },
  (err) => {
    console.error('RESPONSE ERROR:', err);
    return Promise.reject(err);
  }
);
